module.exports = __webpack_public_path__ + "img/oland.d226f795.png";